import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType,
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search";
import { SearchUtils } from "../PA.UIM.Core/SearchUtils";
import { PASearch } from "../PA.Core/PASearch";
import { PAEnvironment } from "../PA.Core/PAEnvironment";

const vUI_Model_Predictor_Search_Fields: { [id: string]: ISearchProviderField } = {
    WB_MODEL_PREDICTOR_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {
            columnName: "WB Model Predictor Id",
            columnResourceName: "colId",
            alignment: HorizAlignment.Left,
        },
        domainOptions: {},
    },
    MODEL_PREDICTOR_NAME: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Model Predictor Name",
            columnResourceName: "colName",
            alignment: HorizAlignment.Left,
        },
        domainOptions: { maxLength: 50 },
    },
    MODEL_PREDICTOR_ID: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Model Predictor Id",
            columnResourceName: "colPId",
            alignment: HorizAlignment.Left,
        },
        domainOptions: { maxLength: 50 },
    },
    MODEL_PREDICTOR_TYPE: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Model Predictor Type",
            columnResourceName: "colType",
            alignment: HorizAlignment.Left,
        },
        domainOptions: { maxLength: 50, domainIds: "PredictorType", useIdAsKey: false },
    },
    AGGREGATION_METHOD: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Aggregation Method",
            columnResourceName: "colAgrMed",
            alignment: HorizAlignment.Left,
        },
        domainOptions: { maxLength: 50, domainIds: "PredictorAggregationMethod", useIdAsKey: true },
    },
    NUMBER_TYPE: {
        type: SearchProviderFieldType.string,
        renderOptions: {
            columnName: "Number Type",
            columnResourceName: "colNumberType",
            alignment: HorizAlignment.Left,
        },
        domainOptions: { maxLength: 50, domainIds: "PredictorNumberType", useIdAsKey: true },
    },
    SORT_ORDER_UI: {
        type: SearchProviderFieldType.number,
        renderOptions: { columnName: "Sort Order", columnResourceName: "colSort", alignment: HorizAlignment.Right },
        domainOptions: {},
    },
    PREDICTOR_FIELDNAME: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: "Field Name", columnResourceName: "colFieldName", alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 },
    },
    COMMENTS: {
        type: SearchProviderFieldType.string,
        renderOptions: { columnName: "Comments", columnResourceName: "colComments", alignment: HorizAlignment.Left },
        domainOptions: { maxLength: 50 },
    },
    WB_TREE_FOLDER_ID: {
        type: SearchProviderFieldType.number,
        renderOptions: {columnName: 'Tree Folder'}
    },
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: "Created Date",
            columnResourceName: "colCreateDt",
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy",
        },
        domainOptions: {},
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: "Modified Date",
            columnResourceName: "colModifiedDt",
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy",
        },
        domainOptions: {},
    },
};

const ModelPredictorSearchProviderBasic: ISearchProvider = {
    keyFields: { id: "WB_MODEL_PREDICTOR_ID", id_ui: "MODEL_PREDICTOR_ID", name: "MODEL_PREDICTOR_NAME" },

    searchProviderFields: vUI_Model_Predictor_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {
            let findRequest = SearchUtils.makeSearchRequest(
                searchRequestSubset,
                "vUI_Model_Predictor_Search",
                this.searchProviderFields,
                [],
            );

            PASearch.findByRequest(findRequest)
                .then((res: any) => {
                    resolve(res);
                })
                .catch((err) => {
                    error(err);
                });
        });
    },
};

const ModelPredictorSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "ModelPredictorSearchProfileByName" },

    profileFilter: [
        { profileFilterName: "Id", searchProviderFieldId: "MODEL_PREDICTOR_ID", renderOptions: {} },
        { profileFilterName: "Name", searchProviderFieldId: "MODEL_PREDICTOR_NAME", renderOptions: {} },
        { profileFilterName: "Comments", searchProviderFieldId: "COMMENTS", renderOptions: {} },
    ], //ISearchFields
    profileDisplayFields: [
        "MODEL_PREDICTOR_NAME",
        "MODEL_PREDICTOR_ID",
        "MODEL_PREDICTOR_TYPE",
        "NUMBER_TYPE",
        "SORT_ORDER_UI",
        "CREATED_DTTS",
        "MODIFIED_DTTS",
        "COMMENTS",
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ModelPredictorSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "", //string;
    profileSorts: [], //ISearchSort[];
};

const ModelPredictorSearch: ISearch = {
    searchName: "Find Model Predictor",
    renderOptions: { ui5ResourceId: "ModelPredictorSearch" },
    searchProfileIdDefault: "default",
    searchProfiles: [ModelPredictorSearchProfileByName],
};
PAEnvironment.registerBusinessObjectSearch(
    "ModelPredictorBO",
    "ModelPredictor",
    ModelPredictorSearch,
    "Model Predictor Search",
);

export { ModelPredictorSearch };
